import dayjs from 'dayjs';
import { SHORT_TIME_FORMAT, TIME_FORMAT } from 'consts/timeFormats';

export const parseStringIntoFormattedStringTime: (time: string) => string = (time) => {
    const parsedDate = dayjs(time, TIME_FORMAT);
    return parsedDate.format(SHORT_TIME_FORMAT);
};
